import * as React from 'react';
import { BalanceMobileContainer } from '../BalanceMobile';
import { CheckoutContainer } from '../Checkout';
import * as styles from './SummaryMobile.css';

export const SummaryMobile = () => {
  return (
    <>
      <div className={styles['balance_container']}>
        <BalanceMobileContainer />
      </div>

      <div className={styles['checkout_container']}>
        <CheckoutContainer />
      </div>
    </>
  );
};
